export const addClassNameToElement = (element, className) => element.classList.add(className)

export const removeWithAnimation = className => {
  const removedElement = document.getElementsByClassName(className)[0]
  if (!removedElement) return

  addClassNameToElement(removedElement, 'removed')
  setTimeout(() => removedElement?.parentElement?.removeChild(removedElement), 1450)
}

let deferredFunctions = []

export const callDeferredFunctionsWhenBecomeVisible = (deferredFunctions, hidden) => {
  if (!hidden) {
    deferredFunctions.forEach(fn => fn())
    return []
  }
  return [...deferredFunctions]
}

export const deferFunctionWhenBecomeHidden = (callback, deferredFunctions, hidden) => {
  if (hidden && !deferredFunctions.includes(callback)) return deferredFunctions.push(callback)
  if (!hidden) return callback()
}

export const deferInterval = (callback, interval) =>
  setInterval(() => deferFunctionWhenBecomeHidden(callback, deferredFunctions, document.hidden), interval)

export const initDeferredIntervalsWrapper = () => {
  window.addEventListener('visibilitychange', () => {
    deferredFunctions = callDeferredFunctionsWhenBecomeVisible(deferredFunctions, document.hidden)
  })
}
